<template lang="pug">
  v-content
    HeaderNabvarSimple
    v-container.fill-height(fluid)
      v-row(align="center" justify="center")
        v-col(cols="12" sm="8" md="4")
          LoginCard(@pinSuccess="loginSuccess" v-bind="translations")
          NotificationSnackbar
</template>

<script>

import LoginCard from '@/components/cards/LoginCard.vue';
import NotificationSnackbar from "@/components/snackbar/NotificationSnackbar";
import HeaderNabvarSimple from '@/components/navbars/HeaderNabvarSimple';

export default {
  name: 'Login',
  components: {
    NotificationSnackbar,
    HeaderNabvarSimple,
    LoginCard,
  },
  computed: {
    translations(){
      return this.$t("components.loginCard");
    },
  },
  created () {
    this.$vuetify.theme.dark = false;
  },
  methods: {
    loginSuccess(){
      this.$router.push('/home');
    },
  }
}
</script>

<style lang="sass">
</style>